// 中文
export default {
  // 首页
  page_home: {
    navMenu:{
      home: '首页',
      caseExchange: '病例交流',
      surgicalVideo: '手术视频',
      internationalConference: '国际会议',
      medicalInformation: '医疗资讯',
      aboutUs: '关于我们',
      aboutTeam:'团队介绍',
      contactUs:'联系我们',
      businessPartner:'合作伙伴',
      privacyAgreement:'隐私条款',
    },
    footer:{
      address:'北京市丰台区丰台北路18号 金唐中心A座21层',
      email:'misnmed@gmail.com',
      jnd:'加拿大',
      jndaddress:'温哥华',
      beijing:'中国',
      lookMore:'浏览更多',
      phone:'(001)6046571180',
    },
    carousel:{
      left:'立即加入',
      right:'了解更多',
    },
    wc:{
      title:'汇聚全球知名医疗专家，微创手术国际化顶级平台。',
      zjtd:'专家团队',
      zjtd_desc:'数万名资深医师，涵盖各专科领域，以专业实力护航医疗质量',
      gjlt:'国际论坛',
      gjlt_desc:'汇聚全球医者智慧，共享临床经验，畅谈疑难病例',
    },
    zj:{
      title:'我们的同行专家',
      desc:'医疗专家深耕领域，以精湛医术和深厚学识，为患者提供权威、可靠的诊疗方案，守护生命每一刻。',
      cyjy:'从业经验',
      ssal:'手术案例',
      xx:'详细',
    },
    pt:{
      title:'深受用户信赖的专业医疗平台，汇聚手术视频共享与交流。',
    },
    pl:{
      title:'看看我们的用户都怎么说'
    },
    case:{
      title1:'医疗学者通过MISN平台',
      title2:'已分享海量病例，助力医学交流与研究',
      csyy:'快来畅所欲言',
      gdbl:'更多病例',
    },
    zx:{
      title:'医学资讯',
      gdzx:'更多资讯',
      lll:'浏览量'
    },
    cj:{
      title:'医疗器械厂家入驻',
      desc:'让你不再纠结如何选购',
      llxq:'了解详情'
    }
  },
  // 病例交流
  page_caseExchange:{
    pushBl:'发布病例',
    fbyy:'发布语言',
    pl:'评论',
    fbpl:'发布评论',
    djsrpl:'点击输入评论',
    delete:'删除',
    recover:'回复',
    fycyw:'翻译成英文',
    srplnr:'请输入评论内容',
    plcg:'评论成功',
    fyz:'翻译中...'
  },
  // 手术视频
  page_surgicalVideo:{
    spzt:'视频专题',
    fbsp:'发布视频',
    tj:'推荐',
    tjsp:'推荐视频',
    follow:'关注',
    sc:'擅长',
    blxx:'病例信息',
  },
  // 国际会议
  page_internationalConference:{
    meetingTime:"会议时间",
    createTime:"创建时间"
  },
  // 团队介绍
  page_aboutTeam:{
    misn:'国际微创医生联盟',
    misnDesc:'国际微创医生联盟(MISN)是一个由来自不同学科的全球知名医疗专家组成的国际化卓越联盟。随着微创手术和机器人手术的迅速发展，迫切需要一个国际化的顶级专业平台，以促进微创技术共享、经验交流和前沿研究成果以及国际化专业培训的传播。MISN专注于微创手术领域，尤其是腹腔镜、内窥镜和机器人手术。该平台为全球外科医生提供了一个专业的在线空间，促进微创技术进步与合作，并在国际医学界推动微创技术的创新与发展。',
    teamMem:'团队成员',
    acadSem:'学术交流研讨会',
  },
  // 关于我们
  page_aboutUs:{
    khfw:'客户服务',
    jghz:'机构合作',
    schz:'市场合作',
    gzsjdd:'地址',
    gztime:'周一至周五 9:00-18:00',
    hzcjrz:'合作厂家入驻',
    hzcjLogin:'合作厂家登录',
    hzcj:'合作厂家',
    cpxx:'产品信息',
    hzcjrzDesc:'在平台上发布公司独家产品信息，快填写信息，立即入驻吧!',
    ckgd:'查看更多',
  },
  // 个人中心
  page_userCenter:{
    edit:'编辑',
    video:'视频',
    sc:'收藏',
    all:'全部',
    gk:'公开',
    sm:'私密',
    shz:'审核中...',
    shwtg:'审核未通过...',
    caseDeleteTitle:'删除后无法恢复',
    caseDeleteDesc:'是否确认删除？',
    caseDeleteBtn:'确认删除',
    caseCancleBtn:'取消',
    yqts:'友情提示',
    yqtsDesc:'所有上传病例须经患者本人同意，并确保不涉及患者隐私。本网站对此不承担相应责任。',
    yqtsVideoDesc:'所有上传视频须经患者本人同意，并确保不涉及患者隐私。本网站对此不承担相应责任。',
    wyzxbty:'我已知晓并同意',
    queren:'确认',
    grxx:'个人信息',
    gh:'更换',
    fansList:'粉丝列表',
    followList:'关注列表',
    zxfb:'最新发布',
    zdbf:'最多播放',
    zddz:'最多点赞',
    caseEditTip:'审核中无法编辑',
    nhmysc:'你还没有收藏',
    zwllsj:'暂无浏览数据',
  },
  // 厂家的
  page_mf:{
    addpro:'新增产品',
    yyly:'应用领域',
    qxzyjly:"请选择一级领域",
    qxzejly:"请选择二级领域",
    xzcg:'新增成功',
    xgcg:'编辑成功',
    bjxx:'编辑信息',
  },
  // 表单
  form:{
    cjmc:'厂家名称:',
    cjmcEn:'厂家英文名称:',
    cjlogo:'厂家logo:',
    lxdh:'联系电话:',
    email:'邮箱:',
    cjjs:'厂家介绍:',
    cjjsEn:'厂家英文介绍:',  
    loginPwd:'登录密码:',
    confirmPwd:'确认密码:',
    qsr:'请输入',
    qxz:'请选择',
    xzwj:'选择文件',
    xzwjTip:'请上传jpg、jpeg、png格式的图片，大小不超过2M',
    ydbty:'已阅读并同意',
    // userxy:'《用户协议》',
    ysxy:'《隐私协议》',
    mzsf:'《免责声明》',
    submit:'提交',
    submitSuccessTitle:'您已提交成功！等待工作人员审核',
    submitSuccessDesc:'预计3个工作日内处理',
    dxdl:'短信登录',
    yxdl:'邮箱登录',
    hqyzm:'获取验证码',
    dxyz:'短信验证',
    emailyz:'邮箱验证',
    cshi:'后重试',
    qstyxy:'请先同意协议',
    zccg:'注册成功',
    fscg:'发送成功',
    signCg:'登录成功',
    saveSucc:'保存成功',
    qtnzddl:'七天内自动登录',
    xs:'姓氏:',
    name:'名字:',
    country:'国家:',
    zyly:'专业领域:',
    otherZyly:'其他专业领域:',
    grjj:'个人简介:',
    ywjj:'英文简介:',
    ywjjzh:'中文简介:',
    sc:'擅长:',
    ywsc:'英文擅长:',
    ywsczh:'中文擅长',
    sjh:'手机号:',
    bcxg:'保存修改',
    bt:'标题:',
    fl:'分类:',
    blxx:'病例信息:',
    chzzl:'从 患者资料、体格检查、疾病诊断、等方面描述手术真实情况，系统将为你自动润色并填入【病例信息】中',
    runse:'AI润色',
    fbfw:'发布范围:',
    gk:'公开(所有用户可见)',
    rc:'日常工作病历记录(仅自己可见)',
    fhbj:'返回编辑',
    qrfb:'确认发布',
    tjcg:'您已提交成功',
    tzdccyksc:'拖拽到此处也可以上传',
    zc:'支持.mp4 .mov .avi',
    scvideo:'上传视频',
    ghvideo:'更换视频',
    scsuccess:'上传完成',
    scfail:'上传失败',
    yscdvideo:'已上传的视频',
    fm:'封面',
    ghfm:'更换封面',
    xtmrdyz:'系统默认选中第一帧为视频封面',
    cpmc:'产品名称:',
    cpmcEn:'产品英文名称:',
    yyly:'应用领域:',
    cptp:'产品图片:',
    cpjs:'产品介绍:',
    cpjsEn:'产品英文介绍:',
    sphzscz:'视频还在上传中',
    xgai:'修改',
    bind:'绑定',
    save:'保存',
    editEmail:'修改邮箱',
    editPhone:'修改手机号',
    bingPhone:'绑定手机号',
    pl_qxafm:'请选择封面',
    pl_qsrYzm:'请输入验证码',
    pl_qsrsjh:'请输入手机号',
    pl_qsrnewsjh:'请输入新的手机号',
    pl_qxzzyly:'请选择专业领域',
    pl_qsrzyly:'请输入专业领域',
    pl_qsrgj:'您的国家',
    pl_qsrxs:'请输入姓氏',
    pl_qsrmz:'请输入名字',
    pl_qsrcjmc:'请输入厂家名称',
    pl_qsrcjmcEn:'请输入厂家英文名称',
    pl_qsrlogo:'请上传厂家logo',
    pl_qsrphone:'请输入联系电话',
    pl_qsrzqPhone:'请输入正确的手机号',
    pl_qsrEmail:'请输入邮箱',
    pl_qsrnewEmail:'请输入新的邮箱',
    pl_qsrzqEmail:'请输入正确的邮箱',
    pl_qsrCjjs:'请输入厂家介绍',
    pl_qsrCjjsEn:'请输入厂家英文介绍',
    pl_qsrPwd:'请输入登录密码',
    pl_qsrConfirmPwd:'请输入确认密码',
    pl_qsrbt:'请输入标题',
    pl_qszfl:'请选择分类',
    pl_qsrblxx:'请输入病例信息',
    pl_qsrFbfw:'请选择发布范围',
    pl_qsrmm:'请输入密码',
    pl_qsccptp:'请上传产品图片',
    pl_qszyyly:'请选择应用领域',
    pl_qsrcpmc:'请输入产品名称',
    pl_qsrcpmcEn:'请输入产品英文名称',
    pl_qsrcpjs:'请输入产品介绍',
    pl_qsrcpjsEn:'请输入产品英文介绍',
  },
  new:'最新',
  hot:'最热',
  jjjx:'即将举行',
  wqhy:'往期会议',
  search:'搜索',
  searchTip:'请输入搜索内容',
  loading:'加载中...',
  noMore:'无更多数据',
  noMoreJQQD:'更多内容敬请期待',
  hmyfbnr:'还没有发布内容',
  back:'返回',
  dyue:'订阅',
  fans:'粉丝',
  bl:'病例',
  myBl:'我的病例',
  mySp:'我的视频',
  mySc:'我的收藏',
  lljl:'浏览记录',
  lang:'语言',
  exit:'退出',
  noSearchData:'未搜索到相关数据',
  yxzx:'医学资讯',
  user:'用户',
  qxGz:'取消关注',
  hg:'回关',
  hxgz:'互相关注',
  ststemNot:'系统通知',
  llck:'立即查看',
  srbt:'输入标题',
  detail:'详情',
  backLogin:'返回登录',
  register:'注册',
  sign:'登录',
  registerBottomTip:'部分国家因地区限制，如果没有收到短信验证码，请改用邮箱注册。',
  sftcdl:'是否退出登录?',
  runseFail:'润色失败',
  sfsc:'是否删除？',
  sccg:'删除成功',
  mmsrbyz:'两次密码输入不一致',
  sdskz:'深度思考中...',
  sdskzFinish:'深度思考完成',
  qxgxy:'请先勾选同意',
  qxdl:'请先登录',
  zdfbpdNUm:'最多发布10个产品',
  dlhjkgksp:'登陆后即可观看完整视频',
  message:"消息",
  zanwu:'暂无',
  sysc:'使用手册',
  pcv:'PC版',
  mobilev:'移动版',
  m_pcv:'PC版使用手册',
  m_mobilev:'移动版使用手册',
  loginTip1:'如您尚无账户，请先',
  loginTip2:'后再登录',
  bannerWorld1:'加入MISN，成为卓越团队的一员，共同推',
  bannerWorld2:'动全球微创技术的创新与进步。',
  zh:'中文',
  // 隐私协议
  privacyAgreement:{
    title:'国际微创医生联盟隐私条款',
    t1:{
      t:'一、引言',
      d:'本平台高度重视您的隐私权与数据安全。本隐私政策阐述了我们如何收集、使用、存储和保护您在使用本平台时提供的个人信息。'
    },
    t2:{
      t:'二、信息收集范围',
      d:'我们可能收集以下信息（限专业用途）：',
      d1:'1.	身份信息（如姓名、职业、医院/机构、医师执照号）',
      d2:'2.	联系方式（如邮箱、手机号、国家/地区）',
      d3:'3.	账户活动数据（登录记录、浏览行为、上传历史）',
      d4:'4.	专业内容（您上传的视频、评论、病例等）',
      d5:'5.	设备信息（IP地址、操作系统、浏览器类型，仅用于安全目的）',
    },
    t3:{
      t:'三、信息使用目的',
      d1:'1.	认证医生身份、保障平台专业性；',
      d2:'2.	提供个性化服务与学术推荐内容；',
      d3:'3.	管理内容发布、专家审核流程；',
      d4:'4.	改进平台性能与用户体验；',
      d5:'5.	履行法律法规或监管要求。',
    },
    t4:{
      t:'四、信息存储与安全',
      d1:'•	所有数据存储于加密服务器，部署在数据合规国家/地区；',
      d2:'•	用户有权随时申请删除或导出其个人数据。'
    },
    t5:{
      t:'五、第三方共享',
      d:'我们不会出售、出租或擅自披露您的信息，除非：',
      d1:'•	经您明确授权同意；',
      d2:'•	为履行法律义务或应对司法请求；',
      d3:'•	与经审核的合作学术机构联合组织培训或发布内容（仅限必要范围）。',
    },
    t6:{
      t:'六、Cookie与追踪技术',
      d:'平台可能使用Cookies提升体验，但不会用于广告追踪。您可在浏览器中关闭Cookies功能。'
    },
    t7:{
      t:'七、您的权利',
      d:'您拥有以下权利：',
      d1:'•	访问、更正或删除您的账户信息；',
      d2:'•	撤回您的同意或关闭账户；',
      d3:'•	向平台投诉数据处理问题。'
    },
    t8:{
      t:'八、政策变更',
      d:'我们可能会定期更新本政策。变更将在平台公告中提前通知，重大变更将通过邮件或App提示告知用户。',
    },
    t9:{
      t:'九、版权',
      d:'MISN 拥有本网站所展示全部材料的版权。'
    },
    t10:{
      t:'十、联系我们',
      d:'若您对本隐私政策有任何疑问，请通过以下方式联系我们：',
      d1:'邮箱: misnmed@gmail.com',
    },
  },
  // 免责声明
  disclaimer:{
    title:'免责声明',
    t1:{
      t:'本平台所展示内容仅供医学专业人员学术交流与教育参考，不作为诊断、治疗或医疗建议的依据。',
    },
    t2:{
      t:'所有手术视频均已去除患者隐私信息，第一作者有责任获取与视频、标识、内容或数据使用相关的患者、机构或医院的同意。禁止未经授权转载。',
    },
  },
  cookie:{
    t1:'本网站使用 Cookie 为您提供更优质的浏览体验。了解更多关于',
    t2:'。如您点击右侧确认按钮，将视为您同意Cookie的使用。',
    jsBtn:'接受'
  },
  //隐私条款
  newPrivacyAgreement:{
    title:'免责声明',
    content:` 本平台所展示内容仅供医学专业人员学术交流与教育参考，不作为诊断、治疗或医疗建议的依据。<br />
      所有手术视频均已去除患者隐私信息，第一作者有责任获取与视频、标识、内容或数据使用相关的患者、机构或医院的同意。禁止未经授权转载。`
  },
  // pc版使用手册
  pcVUse:{
    title:"国际微创医生联盟网站使用手册(PC 版）",
    t1:{
      d1:'本操作手册主要介绍国际微创医生联盟 PC 网站详细使用说明。',
      d2:'预期读者：医生用户、运营人员、项目管理人员、技术开发人员、测试工程师等。',
      d3:'注：若本操作指南的界面截图与实际系统界面有所差异，使用时请以实际界面为准。',
    },
    t2:{
      t:'1.1 注册',
      d:'进入网站 www.misnmed.com 后，未注册的用户点击右上角菜单栏【登录】按钮后，可看到提示“如您尚无账户，请先注册后再登录”，前往注册。',
      d1:'填写个人资料，选择邮箱验证，进行注册。',
      d2:'注册成功后进入登陆页面。',
    },
    t3:{
      t:'1.2 登录',
      d:'已注册账号的用户，点击右上角【登录】按钮，前往登录。',
      d1:'选择通过邮箱验证码进行登录。',
      d2:'登录后即可访问网站。',
    },
    t4:{
      t:'1.3 发布病例',
      d:'医生发布病例交流内容，有三个入口：',
      d1:'入口 1 & 2：点击【病例交流】 -【发布病例】',
      d2:'入口 3：鼠标移入右上角头像，点击【我的病例】，进入个人主页，点击【发布病例】。',
      d3:'同意协议，填写病例交流的内容，选择分类，输入病例信息（可点击【AI 润色】按钮进行润色）。',
      d4:'点击【提交】，进入翻译环节。',
      d5:'系统自动翻译为英语，可手动修改或使用默认翻译。',
      d6:'点击【确认发布】，提交至管理平台审核。',
      d7:'审核结果会通过系统消息提醒。',
      d8:'审核驳回会显示原因，可修改后重新提交；审核通过后内容发布成功。',
    },
    t5:{
      t:'1.4 发布视频',
      d:'医生发布手术视频内容，有三个入口：',
      d1:'入口 1 & 2：点击【手术视频】 -【发布视频】',
      d2:'入口 3：鼠标移入右上角头像，点击【我的视频】，进入个人主页，点击【发布视频】。',
      d3:'同意协议，上传视频，可拖拽上传。',
      d4:'系统自动选择第一帧为封面，也可自行上传封面。',
      d5:'填写视频内容，选择分类，输入病例信息（可使用【AI 润色】按钮）。',
      d6:'点击【提交】，进入翻译环节。',
      d7:'系统自动翻译为英语，可修改或使用默认翻译。',
      d8:'点击【确认发布】，提交审核。',
      d9:'审核结果通过系统消息通知。',
      d10:'审核驳回可修改重新提交；审核通过即发布成功。',
    },
    t6:{
      t:'1.5 病例交流',
      d:'您可以在本模块进行手术病例的心得交流，自主发布病例，或与其他医生进行讨论。',
      d1:'支持通过分类筛选、按最新/最热排序，或关键词搜索。',
      d2:'点击进入病例详情页，查看详细信息。',
      d3:'支持双语切换，并可留言评论。',
    },
    t7:{
      t:'1.6 手术视频',
      d:'您可以观看其他医生分享的视频并交流心得，也可分享自己的手术视频。',
      d1:'支持通过分类筛选、按最新/最热视频排序，或关键词搜索。',
      d2:'点击进入视频详情页，右侧显示作者信息，支持【关注】操作。',
      d3:'病例信息支持双语查看，可留言评论。',
    },
    t8:{
      t:'1.7 国际会议',
      d:'您可以在本模块查看最新国际会议动态，点击进入详情页。',
    },
    t9:{
      t:'1.8 医疗资讯',
      d:'您可以查看最新医疗资讯，支持关键词搜索、按最新/最热排序，点击进入详情页。',
    },
    t10:{
      t:'1.9 个人中心',
      d:'鼠标移入右上角头像，点击头像进入个人中心。',
    },
    t11:{
      t:'1.9.1 编辑个人信息',
      d:'点击【编辑】按钮修改信息，修改后点击保存。'
    },
    t12:{
      t:'1.9.2 关注＆粉丝',
      d:'点击【关注/粉丝】按钮，查看关注用户和粉丝列表。',
    },
    t13:{
      t:'1.9.3 我的病例',
      d:'点击【病例】按钮查看您发布的病例，支持筛选、搜索、编辑、删除操作。'
    },
    t14:{
      t:'1.9.4 我的视频',
      d:'点击【视频】按钮查看您发布的视频，支持筛选、搜索、编辑、删除操作。',
    },
    t15:{
      t:'1.9.5 我的收藏',
      d:'点击【收藏】按钮查看您收藏的内容，支持筛选、搜索、编辑、删除。'
    },
    t16:{
      t:'1.9.6 浏览记录',
      d:'点击【浏览记录】按钮查看历史浏览记录，支持筛选和搜索。'
    },
    bottom:{
      t:'感谢您的使用！'
    }
  },
  // 移动版使用手册
  mbVUse:{
    title:'国际微创医生联盟网站使用手册（移动版）',
    t1:{
      d1:'本操作手册主要介绍国际微创医生联盟网站（移动版）详细使用说明。',
      d2:'预期读者：医生用户、运营人员、项目管理人员、技术开发人员、测试工程师等。',
      d3:'注：若本操作指南与实际系统界面有所差异，使用时请以实际界面为准。',
    },
    t2:{
      t:'1.1 注册',
      d:'进入网站 www.misnmed.com，未注册的用户点击右上角菜单栏【登录】按钮后，可看到提示“如您尚无账户，请先注册后再登录”，前往注册。',
      d1:'填写个人资料，选择邮箱验证，进行注册。',
      d2:'注册成功后进入登陆页面。'
    },
    t3:{
      t:'1.2 登录',
      d:'已注册账号的用户，点击右上角菜单栏【登录】按钮，前往登录。',
      d1:'选择通过邮箱验证码登录。',
      d2:'登录后即可访问网站。',
    },
    t4:{
      t:'1.3 发布病例',
      d:'医生发布病例交流内容，有三个入口：',
      d1:'入口 1&2：点击【病例交流】 -【发布病例】',
      d2:'入口 3：鼠标移入右上角头像，点击【我的病例】，进入个人主页，点击【发布病例】。',
      d3:'同意协议，填写病例交流的内容，选择分类，输入病例信息（可点击【AI 润色】按钮进行润色）。',
      d4:'点击【提交】，进入翻译环节。',
      d5:'系统自动翻译为英语，可手动修改或使用默认翻译。',
      d6:'点击【确认发布】，提交至管理平台审核。',
      d7:'审核结果会通过系统消息提醒。',
      d8:'审核驳回会显示原因，可修改后重新提交；审核通过后内容发布成功。',
    },
    t5:{
      t:'1.4 发布视频',
      d:'医生发布手术视频内容，有三个入口：',
      d1:'入口 1 & 2：点击【手术视频】 -【发布视频】',
      d2:'入口 3：鼠标移入右上角头像，点击【我的视频】，进入个人主页，点击【发布视频】。',
      d3:'同意协议，上传视频，可拖拽上传。',
      d4:'系统自动选择第一帧为封面，也可自行上传封面。',
      d5:'填写视频内容，选择分类，输入病例信息（可使用【AI 润色】按钮）。',
      d6:'点击【提交】，进入翻译环节。',
      d7:'系统自动翻译为英语，可修改或使用默认翻译。',
      d8:'点击【确认发布】，提交审核。',
      d9:'审核结果通过系统消息通知。',
      d10:'审核驳回可修改重新提交；审核通过即发布成功。',
    },
    t6:{
      t:'1.5 病例交流',
      d:'您可以在本模块进行手术病例的心得交流，自主发布病例，或与其他医生进行讨论。',
      d1:'支持通过分类筛选、按最新/最热排序，或关键词搜索。',
      d2:'点击进入病例详情页，查看详细信息。',
      d3:'支持双语切换，并可留言评论。',
    },
    t7:{
      t:'1.6 手术视频',
      d:'您可以观看其他医生分享的视频并交流心得，也可分享自己的手术视频。',
      d1:'支持通过分类筛选、按最新/最热视频排序，或关键词搜索。',
      d2:'点击进入视频详情页，右侧显示作者信息，支持【关注】操作。',
      d3:'病例信息支持双语查看，可留言评论。',
    },
    t8:{
      t:'1.7 国际会议',
      d:'您可以在本模块查看最新国际会议动态，点击进入详情页。',
    },
    t9:{
      t:'1.8 医疗资讯',
      d:'您可以查看最新医疗资讯，支持关键词搜索、按最新/最热排序，点击进入详情页。'
    },
    t10:{
      t:'1.9 个人中心',
      d:'鼠标移入右上角头像，点击头像进入个人中心。',
    },
    t11:{
      t:'1.9.1 编辑个人信息',
      d:'点击【编辑】按钮修改信息，修改后点击保存。'
    },
    t12:{
      t:'1.9.2 关注＆粉丝',
      d:'点击【关注/粉丝】按钮，查看关注用户和粉丝列表。'
    },
    t13:{
      t:'1.9.3 我的病例',
      d:'点击【病例】按钮查看您发布的病例，支持筛选、搜索、编辑、删除操作。',
    },
    t14:{
      t:'1.9.4 我的视频',
      d:'点击【视频】按钮查看您发布的视频，支持筛选、搜索、编辑、删除操作。',
    },
    t15:{
      t:'1.9.5 我的收藏',
      d:'点击【收藏】按钮查看您收藏的内容，支持筛选、搜索、编辑、删除。',
    },
    t16:{
      t:'1.9.6 浏览记录',
      d:'点击【浏览记录】按钮查看历史浏览记录，支持筛选和搜索。',
    },
    bottom:{
      t:'感谢您的使用！'
    }
  }
};